/* Modulo Testimonials — multi-card slider with touch, arrows, dots, autoplay.
   Vanilla, lazy-init, reduced-motion aware. */
(function () {
  'use strict';

  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SWIPE_THRESHOLD = 40;

  function getCardsPerView(track) {
    var styles = window.getComputedStyle(track);
    var cpv = parseFloat(styles.getPropertyValue('--modulo-t-cpv')) || 3;
    var cpvm = parseFloat(styles.getPropertyValue('--modulo-t-cpv-m')) || 1.1;
    return window.innerWidth <= 860 ? cpvm : cpv;
  }

  function getGap(track) {
    var styles = window.getComputedStyle(track);
    return parseFloat(styles.gap) || 0;
  }

  function maxIndex(total, cpv) {
    return Math.max(0, Math.ceil(total - cpv));
  }

  function clearChildren(node) {
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function initSlider(slider) {
    var track = slider.querySelector('.modulo-testimonials__track');
    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.modulo-testimonials__card'));
    if (!cards.length) return;

    var prevBtn  = slider.querySelector('[data-modulo-slider-prev]');
    var nextBtn  = slider.querySelector('[data-modulo-slider-next]');
    var dotsHost = slider.querySelector('[data-modulo-slider-dots]');

    var index = 0;
    var cpv = getCardsPerView(track);
    var max = maxIndex(cards.length, cpv);

    function cardStep() {
      var first = cards[0];
      if (!first) return 0;
      return first.getBoundingClientRect().width + getGap(track);
    }

    function update() {
      var offset = -1 * cardStep() * index;
      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';

      if (prevBtn) prevBtn.disabled = index <= 0;
      if (nextBtn) nextBtn.disabled = index >= max;

      if (dotsHost) {
        var dots = dotsHost.querySelectorAll('button');
        for (var i = 0; i < dots.length; i++) {
          dots[i].setAttribute('aria-selected', i === index ? 'true' : 'false');
        }
      }
    }

    function goTo(i) {
      index = Math.max(0, Math.min(max, i));
      update();
    }

    function next() { goTo(index + 1); }
    function prev() { goTo(index - 1); }

    function buildDots() {
      if (!dotsHost) return;
      clearChildren(dotsHost);
      var pages = max + 1;
      for (var i = 0; i < pages; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        btn.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        (function (idx) {
          btn.addEventListener('click', function () { stopAutoplay(); goTo(idx); });
        })(i);
        dotsHost.appendChild(btn);
      }
    }

    // ─── Autoplay ───
    var autoplay = slider.getAttribute('data-autoplay') === '1';
    var interval = parseInt(slider.getAttribute('data-autoplay-interval'), 10) || 5000;
    var autoplayTimer = null;

    function startAutoplay() {
      if (!autoplay || REDUCE) return;
      stopAutoplay();
      autoplayTimer = setInterval(function () {
        if (index >= max) goTo(0);
        else next();
      }, interval);
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    // ─── Pointer / touch swipe ───
    var pointerStartX = 0;
    var pointerDelta  = 0;
    var dragging      = false;

    function onPointerDown(e) {
      if (e.button !== undefined && e.button !== 0) return;
      dragging = true;
      pointerStartX = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      pointerDelta = 0;
      track.classList.add('is-dragging');
      stopAutoplay();
    }

    function onPointerMove(e) {
      if (!dragging) return;
      var x = e.clientX || (e.touches && e.touches[0].clientX) || 0;
      pointerDelta = x - pointerStartX;
      var offset = -1 * cardStep() * index + pointerDelta;
      track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
    }

    function onPointerUp() {
      if (!dragging) return;
      dragging = false;
      track.classList.remove('is-dragging');
      if (Math.abs(pointerDelta) > SWIPE_THRESHOLD) {
        if (pointerDelta < 0) next();
        else prev();
      } else {
        update();
      }
      pointerDelta = 0;
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', onPointerUp);
    track.addEventListener('pointercancel', onPointerUp);
    track.addEventListener('pointerleave', function () { if (dragging) onPointerUp(); });

    // ─── Wire arrows ───
    if (prevBtn) prevBtn.addEventListener('click', function () { stopAutoplay(); prev(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { stopAutoplay(); next(); });

    // ─── Pause autoplay on hover/focus ───
    slider.addEventListener('mouseenter', stopAutoplay);
    slider.addEventListener('mouseleave', startAutoplay);
    slider.addEventListener('focusin',  stopAutoplay);
    slider.addEventListener('focusout', startAutoplay);

    // ─── Resize handling ───
    var resizeTimer = null;
    function onResize() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        cpv = getCardsPerView(track);
        max = maxIndex(cards.length, cpv);
        if (index > max) index = max;
        buildDots();
        update();
      }, 100);
    }
    window.addEventListener('resize', onResize);

    // ─── Init ───
    buildDots();
    update();
    startAutoplay();
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-slider]', initSlider);
    } else {
      var sliders = document.querySelectorAll('[data-modulo-slider]');
      for (var i = 0; i < sliders.length; i++) initSlider(sliders[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
